import styleInject from './../../externals/style-inject/dist/style-inject.es.js';

var css_248z = ".FooterComponent-module_shopFooter__Matj4 {\n  width: 100%;\n  display: flex;\n  z-index: 1;\n  position: relative;\n  flex-direction: column;\n  justify-content: center;\n}";
var styles = {"shopFooter":"FooterComponent-module_shopFooter__Matj4"};
styleInject(css_248z,{"insertAt":"top"});

export { styles as default };
//# sourceMappingURL=FooterComponent.module.scss.js.map
